export const EMAIL_TAB_CONFIG = [
    { id: 'invites', label: "Invites"},
    { id: 'autoAssign', label: "Auto-Assign Courses"},
    { id: 'reminders', label: "Reminders"},
    { id: 'oneClick', label: "One-Click Courses"},
    { id: 'contentPacks', label: "Content Packs"}
];
